import { GetTotalsUnivers } from './GetTotalsUnivers';

export const JumbotronDatas = (par, att, ren, arc) => {
    let datas = [
        { label: `${par.length} parcs` },
        { label: `${GetTotalsUnivers(par)} univers` },
        { label: `${att.length} attractions` },
        { label: `${ren.length} rendez-vous` },
        { label: `${arc.length} archives` },
    ];
    return datas;
}